import React, { useMemo } from 'react';

import { AutocompleteState } from 'component/Layout/Autocomplete/types';

import ErrorBoundary from 'utility/Debug/ErrorBoundary';

import { Iata } from 'types/Search/airport';
import { AirportValue } from 'types/Search/filter';

import { CustomSearchInputClassList } from '../Input/types';

import Autocomplete from './__context';
import { getCleanedAirportList } from './__helper/airport';
import { convertValueToUrlParam } from './__helper/convert';
import { useAirportApi } from './__hooks/useAirportApi';
import Search from './Search';
import { AirportAcItem } from './types';

interface AirportProps {
    airportValue: AirportValue<Iata>;
    onValueChange: (value: AirportValue<Iata>) => void;
    onLastSearchesClick?: () => void;
    placeholder: string;
    label: string;
    customClassList?: CustomSearchInputClassList;
}

const Airport = ({
    airportValue,
    onValueChange,
    placeholder,
    label,
    customClassList,
}: AirportProps) => {
    const { searchResultProvider } = useAirportApi();
    const cleanedAirportList = getCleanedAirportList(airportValue);

    const initialAirportState: AutocompleteState<Array<AirportAcItem>, Iata> =
        useMemo(
            () => ({
                config: {
                    threshold: 2,
                    searchResultProvider,
                },
                currentValue: cleanedAirportList,
                recentValue: cleanedAirportList,
                results: [],
            }),
            [searchResultProvider, cleanedAirportList]
        );
    const airportParam = useMemo(
        () => convertValueToUrlParam(cleanedAirportList),
        [cleanedAirportList]
    );

    return (
        <ErrorBoundary>
            <Autocomplete key={airportParam} initialState={initialAirportState}>
                <Search
                    airportValue={cleanedAirportList}
                    onSubmitValue={onValueChange}
                    placeholder={placeholder}
                    label={label}
                    customClassList={customClassList}
                />
            </Autocomplete>
        </ErrorBoundary>
    );
};

export default Airport;
